import React from "react";


const Footer = (props) => (
	<footer className="page-footer font-small text-white lighten-5 bg_verde mt-3">
		
	</footer>
);

export default Footer;
